import type { Transcript } from '../../../Transcript';
import type { TextAlignment } from '../../../../enums';
import type { CanvasTextStyleRenderer } from '../../../asset/TextAsset/renderer/CanvasTextStyleRenderer';
import { CanvasEvenlyLayoutWordMetrics } from '../../../asset/TextAsset/metrics/CanvasEvenlyLayoutWordMetrics';
import { generateWordMetricsWhichFitWithinMaxWidth } from '../../../asset/TextAsset/metrics/CanvasTextMetrics';

/**
 * The minimum duration in milliseconds to be considered a pause.
 */
const MIN_PAUSE_DURATION = 2000;

export const buildMetricsForFancyCaptions = ({
    transcript,
    alignment,
    style,
    maxWidth,
    maxHeight,
}: {
    transcript: Transcript;
    alignment: TextAlignment;
    style: CanvasTextStyleRenderer;
    maxWidth: number;
    maxHeight: number;
}) => {
    let wordIndexOffset = 0;
    return transcript.getTimeRangesWithoutPauses(MIN_PAUSE_DURATION).flatMap((timeRange) => {
        const tempTranscript = transcript.getTrimmedTranscript([
            [timeRange.startTime, timeRange.endTime],
        ]);
        const { wordsWithSpaces, sourceWordReferenceIndices } =
            tempTranscript.generateWordsFromTranscript(wordIndexOffset);

        // get the last word index (-1 are spaces)
        wordIndexOffset = sourceWordReferenceIndices.filter((num) => num !== -1).pop();
        wordIndexOffset += 1;

        const wordMetricsList = generateWordMetricsWhichFitWithinMaxWidth({
            words: wordsWithSpaces,
            highlightAreas: [],
            sourceWordReferenceIndices,
            normalStyle: style,
            highlightStyle: style,
            maxWidth,
            wordBreak: true,
        });

        return CanvasEvenlyLayoutWordMetrics.layout({
            wordMetricsList,
            alignment,
            style,
            wordBreak: true,
            maxWidth,
            maxHeight,
            removeTrailingPunctuationOnLastLineFromLastChunk: true,
        });
    });
};
